import {
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Background() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >
        <Box
          pt={5}
          className="opacityTop opacityDown"
        >
          <Center>
            <Box
              w={{ base: "full", md: "4xl", xl: "8xl" }}
              pt={{ base: 10 }}
              align="center"
            >
              <SectionHeading
                title="Background"
              />
            </Box>
          </Center>
        </Box>

        <Box className="opacityBottom">
          <Center>
            <Box
              w={{ base: "full", md: "3xl", xl: "6xl" }}
            >
              <Text
                pt={10}
                pb={10}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="We are aware of the importance of technology for the future and how young students commit all their resources and those of their families to study it. This is not easy when you come from a vulnerable community, with low-erns and continually facing difficulties." />
              </Text>

              <Text
                pb={10}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="Completing a college degree can be a project that many low-income young people are unable to complete because the financial difficulties faced by their families do not allow use the scarce economic resources for their studies." />
              </Text>

              <Text
                pb={10}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="Most of these studies around machine learning, data science, data engineer and related fields are not available in their localities, which is why most of these students go abroad to access this knowledge." />
              </Text>

              <Text
                pb={{ base: 20, md: 40 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="Financially everything becomes more complex when you come from a low-income country and travel to a country with a higher GDP." />
              </Text>

            </Box>
          </Center>
        </Box>
      </Box>
    </>
  );
}